import Vue from 'vue';
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib'
import VuetifyToast from 'vuetify-toast-snackbar'
import * as Message from '../components/Message';

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon
  }
})

Vue.use(VuetifyToast, {
  x: 'right', // 默认
  y: 'top', // 默认
  color: 'info', // 默认
  icon: '',
  iconColor: '', // 默认
  classes: [
    'us-vt-body'
  ],
  timeout: 3000, // 默认
  centered: true,
  dismissable: true, // 默认
  multiLine: false, // 默认
  vertical: false, // 默认
  queueable: false, // 默认
  showClose: false, // 默认
  closeText: '', // 默认
  closeIcon: 'close', // 默认
  closeColor: '', // 默认
  slot: [], // 默认
  shorts: {
    custom: {
      color: 'purple'
    }
  },
  property: '$toast' // 默认
})

Vue.use(Message);

export default new Vuetify();
